import { Box, Typography, useTheme } from '@mui/material';

import SectionTitle from '../../components/SectionTitle';

const contents = [
  'An thần có ý thức liên quan đến việc tiêm một loại thuốc an thần gọi là midazolam qua ống thông tĩnh mạch. An thần có ý thức giúp giảm đau và gây mất trí nhớ mà không gây mất ý\nthức hoàn toàn. Ngoài việc giúp bệnh nhân không cảm thấy đau trong quá trình thủ thuật, an thần có ý thức cũng làm giảm căng thẳng và lo lắng liên quan đến thủ thuật. Vì vậy,\nmidazolam thường được sử dụng trong các trường hợp khi bệnh nhân có mức độ lo lắng cao hoặc sợ hãi các thủ thuật nội soi.',
  'Đối với một số người, an thần có ý thức gây ra nhiều khó khăn hơn khi đưa vào ống nội soi. Hơn nữa, trong một số trường hợp, không thể gây ngủ dù đã sử dụng liều lượng lớn thuốc. Tuy',
  'nhiên, việc tăng liều thêm không được phép do tác dụng phụ của midazolam. Tác dụng phụ của việc sử dụng midazolam bao gồm khó thở, giảm huyết áp, tăng nhịp tim, cũng như nấc',
  'cụt và ho. Những triệu chứng này thường biến mất tự nhiên mà không cần điều trị đặc biệt. Trong những trường hợp hiếm, những tác dụng phụ nghiêm trọng như ngừng hô hấp và/hoặc',
  'ngừng tim có thể xảy ra, và chăm sóc khẩn cấp sẽ được cung cấp trong thời gian này. Việc sử dụng midazolam bị chống chỉ định đối với những người cao tuổi, có huyết áp thấp, các vấn',
  'đề về hô hấp, các vấn đề về tim hoặc các tình trạng y tế khác.',
];

const contents2 = [
  'Đối với những người chọn an thần có ý thức, bệnh nhân cần phải có bạn bè hoặc thành viên gia đình đi cùng vào ngày kiểm tra, vì thuốc sẽ mất khoảng 2 giờ hoặc lâu hơn để hết tác dụng.\nNgoài ra, bệnh nhân không nên lái xe sau thủ thuật.',
  'Tôi đã nhận được đủ thông tin về bản chất, mục đích và tác dụng phụ của midazolam, và tôi đồng ý sử dụng midazolam trong quy trình này. Tôi hiểu rằng trong quá trình thủ thuật, có thể\nxảy ra điều gì đó bất ngờ đòi hỏi phải thực hiện một quy trình khác hoặc khác với tôi (bệnh nhân). Nếu có điều gì đó bất ngờ xảy ra trong quá trình thủ thuật, tôi khoản yêu cầu và cho phép\nbác sĩ của tôi (bệnh nhân) làm những gì là cần thiết và phù hợp về mặt y tế cho tôi (bệnh nhân), bao gồm thực hiện một thủ tục hoặc xét nghiệm khác.',
  'Vui lòng viết "Tôi đã nghe" vào chỗ trống được cung cấp, nếu bạn đã nghe về các triệu chứng và điều trị, rủi ro và các biến chứng có thể xảy ra.',
];

const CautionList = () => {
  const { palette } = useTheme();

  return (
    <>
      <SectionTitle title="Phiếu Chấp Thuận Sau Khi Được Giải Thích Về An Thần Có Ý Thức" />
      <Box
        sx={{
          width: '98%',
          margin: '48px auto 24px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{
                  fontWeight: '400',
                  fontSize: '14px',
                  lineHeight: '24px',
                  marginBottom: '20px',
                  whiteSpace: 'pre',
                }}
              >
                {v}
              </Typography>
            );
          }
          return (
            <Typography
              sx={{ fontWeight: '400', fontSize: '14px', lineHeight: '24px' }}
            >
              {v}
            </Typography>
          );
        })}
      </Box>

      <Box sx={{ width: '98%', margin: '0px auto 24px auto' }}>
        {contents2.map((v, i) => {
          if (i === 2) {
            return (
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '14px',
                  lineHeight: '24px',
                  color: `${palette.primary.dark}`,
                }}
              >
                {v}
                <p />
              </Typography>
            );
          }
          return (
            <Typography
              sx={{ fontWeight: '400', fontSize: '14px', lineHeight: '24px' }}
            >
              {v}
              <p />
            </Typography>
          );
        })}
      </Box>
    </>
  );
};

export default CautionList;
